// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/Background-3.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.nav-image::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  top: 00px;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  opacity: 1;
}
ul {
  list-style: none;
  padding: 4px;
  margin: unset;
}

li {
  padding: 14px;
  transition: all linear 0.3s;
}

li:hover {
  background: rgb(249 115 22);
  cursor: pointer;
  color: #fff;
}

.dropdown-menu {
  position: absolute;
  background: rgb(8 145 178);
  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  transition: all linear 0.3s;
}

.fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}

/* PhoneInputCustomcss */
.custom-phone-input .form-control {
  width: 100% !important;
  height: 110% !important;
  background-color: rgb(229 229 229) !important; /* Tailwind bg-neutral-200 */
  /* padding: 12px !important; Tailwind p-3 */
  border: 0 !important;
  outline: none !important;
  border-radius: 0.375rem !important; /* Tailwind rounded-md */
  color: #4b5563 !important; /* Tailwind text-gray-600 */
}

.custom-phone-input .flag-dropdown {
  background-color: #e5e7eb !important; /* Tailwind bg-neutral-200 */
  border: 0 !important;
  outline: none !important;
  border-radius: 0.375rem 0 0 0.375rem !important; /* Tailwind rounded-l-md */
}

.custom-phone-input {
  display: flex;
  width: 100%;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,WAAW;EACX,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6CAA6C,EAAE,4BAA4B;EAC3E,2CAA2C;EAC3C,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC,EAAE,wBAAwB;EAC5D,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,oCAAoC,EAAE,4BAA4B;EAClE,oBAAoB;EACpB,wBAAwB;EACxB,+CAA+C,EAAE,0BAA0B;AAC7E;;AAEA;EACE,aAAa;EACb,WAAW;AACb","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.nav-image::before {\n  content: \"\";\n  background-image: url(\"./assets/images/Background-3.png\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: fixed;\n  top: 00px;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: -1;\n  opacity: 1;\n}\nul {\n  list-style: none;\n  padding: 4px;\n  margin: unset;\n}\n\nli {\n  padding: 14px;\n  transition: all linear 0.3s;\n}\n\nli:hover {\n  background: rgb(249 115 22);\n  cursor: pointer;\n  color: #fff;\n}\n\n.dropdown-menu {\n  position: absolute;\n  background: rgb(8 145 178);\n  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  transition: all linear 0.3s;\n}\n\n.fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  width: 100%;\n}\n\n/* PhoneInputCustomcss */\n.custom-phone-input .form-control {\n  width: 100% !important;\n  height: 110% !important;\n  background-color: rgb(229 229 229) !important; /* Tailwind bg-neutral-200 */\n  /* padding: 12px !important; Tailwind p-3 */\n  border: 0 !important;\n  outline: none !important;\n  border-radius: 0.375rem !important; /* Tailwind rounded-md */\n  color: #4b5563 !important; /* Tailwind text-gray-600 */\n}\n\n.custom-phone-input .flag-dropdown {\n  background-color: #e5e7eb !important; /* Tailwind bg-neutral-200 */\n  border: 0 !important;\n  outline: none !important;\n  border-radius: 0.375rem 0 0 0.375rem !important; /* Tailwind rounded-l-md */\n}\n\n.custom-phone-input {\n  display: flex;\n  width: 100%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
